
import ajax from './index'
import apiEnv from './apiEnv'

// 获取工单每日统计数据
export function getJobDayStatisticalData(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/JobDayStatisticalData`, data)
}

//获取每天发单的列表
export function getJobSendJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetSendJobList`, data)
}

//获取匹配完成工单每日统计数据
export function getJobMatchSucList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetJobMatchSucList`, data)
}
//获取匹配中工单每日统计数据
export function getJobMatchingList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetJobMatchingList`, data)
}
//获取待付款工单每日统计数据
export function getWaitPayJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetWaitPayJobList`, data)
}
//获取挂起工单每日统计数据
export function getHangUpJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetHangUpJobList`, data)
}

//获取支付信息费用工单统计数据
export function getPayInfoAmountJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetPayInfoAmountJobList`, data)
}
//获取道具费用统计的单子
export function getPropAmountJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetPropAmountJobList`, data)
}
//获取发票单子
export function getInvoiceJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetInvoiceJobList`, data)
}

//获取承接数据统计
export function getReceiverJobStatistice(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetReceiverJobStatistice`, data)
}

//获取工单利润率数据统计
export function getAmountRateStattistice(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetAmountRateStattistice`, data)
}

//获取好评数据统计
export function getGoodEvaluateStattistice(data) {
    return ajax.post(`${apiEnv.api4}/api/JobStatistics/GetGoodEvaluateStattistice`, data)
}
